export default "__VITE_ASSET__yoRj2U7A__"